import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Constants } from '../../shared/Constants';
import { Observable } from 'rxjs/Observable';
import { ResponseContentType, Http, RequestOptionsArgs, Headers } from '@angular/http';
import { Params } from '@angular/router';

@Injectable()
export class ReportesService {

  constructor(private http: HttpClient, private _http: Http) {

  }

  DetailReportBetweenDates(startDate, endDate) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    const params = new HttpParams().set('start_date', startDate).append('end_date', endDate);
    return this.http.get(Constants.URL_BACKEND + '/tasks/DetailReportBetweenDates', { headers: headers, params: params });
  }

  DetailReportBetweenDatesByUser(startDate, endDate) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    const params = new HttpParams().set('start_date', startDate).append('end_date', endDate);
    return this.http.get(Constants.URL_BACKEND + '/tasks/DetailReportBetweenDatesByUser', { headers: headers, params: params });
  }

  ListPeopleNotWorking(startDate) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    const params = new HttpParams().set('start_date', startDate);
    return this.http.get(Constants.URL_BACKEND + '/tasks/ListPeopleNotWorking', { headers: headers, params: params });
  }

  exportExcel(headersArray, dataArray): Observable<any> {
    const headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    let optionArgs: RequestOptionsArgs;
    optionArgs = {
      headers: headers,
      responseType: ResponseContentType.Blob
    };
    const body = { headersArray: headersArray, dataArray: dataArray };
    return this._http.post(Constants.URL_BACKEND + '/reports/exportTableToExcel', body, optionArgs);
  }

  exportExcelBilling(headersArray, dataArray,totalSoles, totalDolares): Observable<any> {
    const headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    let optionArgs: RequestOptionsArgs;
    optionArgs = {
      headers: headers,
      responseType: ResponseContentType.Blob
    };
    const body = { headersArray: headersArray, dataArray: dataArray, totalSoles: totalSoles, totalDolares: totalDolares };
    return this._http.post(Constants.URL_BACKEND + '/reports/exportTableToExcelBilling', body, optionArgs);
  }

  exportExcelBudget(headersArray, dataArray,montoFinal): Observable<any> {
    const headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    let optionArgs: RequestOptionsArgs;
    optionArgs = {
      headers: headers,
      responseType: ResponseContentType.Blob
    };
    const body = { headersArray: headersArray, dataArray: dataArray, montoFinal: montoFinal };
    return this._http.post(Constants.URL_BACKEND + '/reports/exportTableToExcelBudget', body, optionArgs);
  }

  exportReportBilling(): Observable<any> {
    const headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    let optionArgs: RequestOptionsArgs;
    optionArgs = {
      headers: headers,
      responseType: ResponseContentType.Blob
    };
    return this._http.get(Constants.URL_BACKEND + '/reports/billing', optionArgs);
  }


  exportDetailedExcel(start_date, end_date): Observable<any> {
    const headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    let optionArgs: RequestOptionsArgs;
    optionArgs = {
      headers: headers,
      responseType: ResponseContentType.Blob
    };
    return this._http.get(Constants.URL_BACKEND + '/reports/detailedReport?start_date=' + start_date + '&end_date=' + end_date, optionArgs);
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/reportes.service.ts